import React, { Fragment } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import { ConnectedRouter } from 'react-router-redux';
import Modal from 'react-modal';
import { slugify } from '../helpers';
import Router from './Router';
import * as actionCreators from '../actions/actionCreators';
import App from './App';
import Industry from './Industry';
import Product from './Product';
import IndustrySub from './IndustrySub';
import store, { history } from '../store';

class Root extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isGuideOpen: false,
      modalIsOpen: false,
      isFilterOpen: false,
      width: window.innerWidth,
      showInstallBanner: false,
      toast: false
    };

    this.toggleGuide = this.toggleGuide.bind(this);
    this.toggleFilter = this.toggleFilter.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.bookmarkPage = this.bookmarkPage.bind(this);
  }

  componentWillMount() {
    window.addEventListener('resize', this.handleWindowSizeChange);
  }

  componentDidMount() {
    this.props.fetchIndustries();
    this.props.fetchProducts();
    this.props.fetchAppetites();
    this.props.fetchResources();
    this.props.fetchContacts();
    
    // Detects if device is mobile
    const isMobile = () => {
      const userAgent = window.navigator.userAgent.toLowerCase();
      return /iphone|ipad|ipod|android/.test(userAgent);
    };
    // Detects if device is in standalone mode
    const isInStandaloneMode = () =>
      'standalone' in window.navigator && window.navigator.standalone;

    // Checks if should display install popup notification:
    if (isMobile() && !isInStandaloneMode()) {
      this.setState({ showInstallBanner: true });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange);
  }

  // Width handler
  handleWindowSizeChange = () => {
    const { width } = this.state;
    this.setState({
      width: window.innerWidth,
      notMobile: width >= 767,
    });
  };

  // Open User Guide/add blur
  toggleGuide() {
    const { width, isGuideOpen } = this.state;
    const mobile = width < 767;
    if (mobile) {
      this.setState({
        modalIsOpen: true,
        isGuideOpen: false,
      });
    } else {
      this.setState({
        isGuideOpen: !isGuideOpen,
      });
    }
  }

  // Handle bookmark logic
  bookmarkPage(e) {
    const bookmarkURL = window.location.href;
    const bookmarkTitle = document.title;
    const userAgent = window.navigator.userAgent.toLowerCase();
    e.preventDefault();
    if (window.sidebar && window.sidebar.addPanel) {
      // Firefox <=22
      window.sidebar.addPanel(bookmarkTitle, bookmarkURL, '');
    } else if (window.external && 'AddFavorite' in window.external) {
      // IE Favorites 
      window.external.AddFavorite(bookmarkURL, bookmarkTitle);
      // Set toast to pop for iOS
    } else if (/iPhone|iPad|iPod/i.test(userAgent)) {
      if(window.navigator.standalone){
        alert(`This app has already been added to your home screen.`);
      }
      else{
        this.setState({ toast: !this.state.toast });
        setTimeout( () => {
          this.setState({ toast: false});
        }, 5000);
      }
    } else if (/Android/i.test(userAgent)) {
      alert(`Press the Star or Menu icon (upper right) to bookmark this app or add to your home screen.`);
    } else {
      // Other browsers (mainly WebKit & Blink - Safari, Chrome, Opera 15+)
      alert(`Press ${/Mac/i.test(navigator.platform) ? 'Cmd' : 'Ctrl'}+D to bookmark this page.`);
    }
    return false;
  }

  closeModal() {
    this.setState({ modalIsOpen: false });
  }

  // Toggle filter form
  toggleFilter() {
    this.setState({
      isFilterOpen: !this.state.isFilterOpen,
    });
  }

 

  render() {
    const { showInstallBanner, modalIsOpen, isGuideOpen, isFilterOpen, toast } = this.state || {};

    return (
      <ConnectedRouter history={history}>
        <Switch>
          <Route
            exact
            path="/"
            render={props => (
              <App
                {...props}
                {...this.props}
                toggleGuide={this.toggleGuide}
                toggleFilter={this.toggleFilter}
                isGuideOpen={isGuideOpen}
                modalIsOpen={modalIsOpen}
                closeModal={this.closeModal}
                bookmarkPage={this.bookmarkPage}
                showInstallBanner={showInstallBanner}
                toast={toast}
              />
            )}
          />
          <Route
            path="/industries/:industryId/:sectorId"
            render={props => (
              <Industry
                {...props}
                {...this.props}
                toggleGuide={this.toggleGuide}
                toggleFilter={this.toggleFilter}
                isFilterOpen={isFilterOpen}
                isGuideOpen={isGuideOpen}
                modalIsOpen={modalIsOpen}
                closeModal={this.closeModal}
                bookmarkPage={this.bookmarkPage}
                showInstallBanner={showInstallBanner}
                toast={toast}
              />
            )}
          />
          <Route
            path="/industries/:industryId/"
            render={props => (
              <IndustrySub
                {...props}
                {...this.props}
                toggleGuide={this.toggleGuide}
                isGuideOpen={isGuideOpen}
                modalIsOpen={modalIsOpen}
                closeModal={this.closeModal}
                bookmarkPage={this.bookmarkPage}
                showInstallBanner={showInstallBanner}
                toast={toast}
              />
            )}
          />
          <Route
            path="/products/:productId"
            render={props => (
              <Product
                {...props}
                {...this.props}
                toggleGuide={this.toggleGuide}
                toggleFilter={this.toggleFilter}
                isFilterOpen={isFilterOpen}
                isGuideOpen={isGuideOpen}
                modalIsOpen={modalIsOpen}
                closeModal={this.closeModal}
                bookmarkPage={this.bookmarkPage}
                showInstallBanner={showInstallBanner}
                toast={toast}
              />
            )}
          />
          <Route
            render={props => (
              <App
                {...props}
                {...this.props}
                toggleGuide={this.toggleGuide}
                isGuideOpen={isGuideOpen}
                modalIsOpen={modalIsOpen}
                closeModal={this.closeModal}
                bookmarkPage={this.bookmarkPage}
                showInstallBanner={showInstallBanner}
                toast={toast}
              />
            )}
          />
        </Switch>
      </ConnectedRouter>
    );
  }
}

Modal.setAppElement('.app');

const mapStateToProps = state => ({
  industries: state.industries,
  products: state.products,
  appetites: state.appetites,
  resources: state.resources,
  contacts: state.contacts,
});

const mapDispatchToProps = dispatch => bindActionCreators(actionCreators, dispatch);

const Wrap = connect(
  mapStateToProps,
  mapDispatchToProps
)(Root);

export default Wrap;



// WEBPACK FOOTER //
// ./src/components/Root.js